import { render, staticRenderFns } from "./CommunityChart.vue?vue&type=template&id=32b1efd4&scoped=true&"
import script from "./CommunityChart.vue?vue&type=script&lang=js&"
export * from "./CommunityChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b1efd4",
  null
  
)

export default component.exports